<div class="container">

  <button mat-raised-button color="primary" (click)="changeLanguage('nl')">
    <span>Nederlands</span>
  </button>

  <button mat-raised-button color="primary" (click)="changeLanguage('en')">
    <span>English</span>
  </button>

  <button mat-raised-button color="primary" (click)="changeLanguage('fr')">
    <span>Français</span>
  </button>

  <button mat-raised-button color="primary" (click)="changeLanguage('de')">
    <span>Deutsch</span>
  </button>
</div>
